import { get } from 'lodash/fp';
import axios from './axios';

export default async (configurationGuid, selections, ruleSet = 'immediate', quantity = 1) => {
  const url = `/api/configuratorApi/ExecuteProductRulesForMandiEstimates?guid=${configurationGuid}`;
  const transformedPayload = {
    Q: quantity,
    OptionDetails: selections,
  };
  const command = {
    P: transformedPayload,
    RuleSet: ruleSet,
  };
  const response = await axios.post(url, { ...command });
  return get('data')(response.data);
};
